// extracted by mini-css-extract-plugin
module.exports = {"message":"NoActiveOrganizations_message__3t-XZ","contactUs":"NoActiveOrganizations_contactUs__2Tocz","shareIcon":"NoActiveOrganizations_shareIcon__3I924"};